import { render, staticRenderFns } from "./GoodsAddressChoose.vue?vue&type=template&id=174ca200&scoped=true&"
import script from "./GoodsAddressChoose.vue?vue&type=script&lang=js&"
export * from "./GoodsAddressChoose.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAddressChoose.vue?vue&type=style&index=0&id=174ca200&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174ca200",
  null
  
)

export default component.exports